import { render, staticRenderFns } from "./CareShow.vue?vue&type=template&id=6fc69f96&scoped=true&"
import script from "./CareShow.vue?vue&type=script&lang=js&"
export * from "./CareShow.vue?vue&type=script&lang=js&"
import style0 from "./CareShow.vue?vue&type=style&index=0&id=6fc69f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc69f96",
  null
  
)

export default component.exports